import { render, staticRenderFns } from "./AcceptExtension.vue?vue&type=template&id=b828c038&"
import script from "./AcceptExtension.vue?vue&type=script&lang=js&"
export * from "./AcceptExtension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports